module.exports = __webpack_public_path__ + "img/headshot.b0995850.jpg";